class WorksSlider {
  constructor(element) {
    this.$element = element;
    this.slider = null;

    this.init();
  }

  init() {
    if (!this.slider) {
      this.slider = new Swiper(this.$element, {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: '.works-slider__arrow--next',
          prevEl: '.works-slider__arrow--prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
    }
  }

  update() {
    if (this.slider) {
      this.slider.update();
    }
  }
}

const initSliders = () => {
  const $sliders = document.querySelectorAll('.js-works-slider');

  window.worksSlidersList = [];
  if ($sliders.length) {
    $sliders.forEach((slider) => window.worksSlidersList.push(new WorksSlider(slider)));
  }
};

export {WorksSlider, initSliders};
